import { HttpEvent, HttpHandler, HttpInterceptor, HttpParameterCodec, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Encodiert alle in Url-Parametern resevierten Zeichen.
 * Von Angular werden folgende Zeichen nicht encodiert: !*();:@+$,/?=
 *
 * Insbesondere + und , sind problematisch.
 * Siehe https://jira.t-systems-mms.eu/browse/SPP-1382
 *
 * Diese Fix stammt von:
 * https://github.com/angular/angular/issues/11058#issuecomment-717239897
 */
@Injectable()
export class EncodeUrlParamsSafelyInterceptor implements HttpInterceptor, HttpParameterCodec {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const newParams = new HttpParams({
            fromString: req.params.toString(),
            encoder: this,
        });

        return next.handle(req.clone({
            params: newParams,
        }));
    }

    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }

    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}
